import * as types from "./types";

export const addEvaluationEventRequest = (payload) => ({
  type: types.ADD_EVALUATION_EVENT_REQUEST,
  payload,
});

//Submit form
export const submitEvaluationEventRequest = (payload) => ({
  type: types.SUBMIT_EVALUATION_EVENT_REQUEST,
  payload,
});

export const viewFormRequest = (payload) => ({
  type: types.VIEW_FORM_REQUEST,
  payload,
});

export const viewFormResponse = (payload) => ({
  type: types.VIEW_FORM_RESPONSE,
  payload,
});

export const getEvaluationRequest = (payload) => ({
  type: types.GET_EVALUATION_REQUEST,
  payload,
});

export const getEvaluationsResponse = (payload) => ({
  type: types.GET_EVALUATION_RESPONSE,
  payload,
});

export const updateEvaluationRequest = (payload) => ({
  type: types.UPDATE_EVALUATION_REQUEST,
  payload,
});

export const updateEvaluationResponse = (payload) => ({
  type: types.UPDATE_EVALUATION_RESPONSE,
  payload,
});
